var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
import { useTranslation } from 'react-i18next';
import { PageNames, BIAnalytics } from '@amzn/atoz-shiftapp-utilities';
import { View } from '@amzn/atoz-web/View';
import { Text } from '@amzn/atoz-web/Text';
import { useBreakpoints } from '@amzn/atoz-web/Responsive';
import { getGoldBenefitBadgeSize } from './GoldBenefitViewUtil';
export var GoldBenefitView = function (_a) {
    var isGoldenEmployee = _a.isGoldenEmployee, handleClick = _a.handleClick, _b = _a.analyticsPageName, analyticsPageName = _b === void 0 ? PageNames.DASHBOARD : _b;
    var t = useTranslation().t;
    var matches = useBreakpoints().matches;
    var ariaLabel = React.useMemo(function () {
        return "".concat(t('ess_shifts_dashboard_weeklySummary_goldBenefits_rewardStatus')).concat(isGoldenEmployee
            ? t('ess_shifts_dashboard_weeklySummary_goldBenefits_medal_gold')
            : t('ess_shifts_dashboard_weeklySummary_goldBenefits_medal_earnGold'));
    }, [isGoldenEmployee]);
    var renderActiveButtonContent = function () {
        return (React.createElement(GoldBenefitText, { "data-testid": "GoldBenefitText", fontSize: "T200" }, t('ess_shifts_dashboard_weeklySummary_goldBenefits_medal_gold')));
    };
    var renderInactiveButtonContent = function () {
        return (React.createElement(GoldBenefitTextInactive, { "data-testid": "GoldBenefitTextInactive", fontSize: "T200" }, t('ess_shifts_dashboard_weeklySummary_goldBenefits_medal_earnGold')));
    };
    return (React.createElement(GoldBenefitBadge, { "alt-text": t('ess_common_button'), "aria-label": ariaLabel, onClick: function () {
            BIAnalytics.clickOnRewardIcon(analyticsPageName);
            handleClick();
        }, "data-testid": "GoldBenefitBadge", isGoldenEmployee: isGoldenEmployee, isMobileViewport: !!matches.s }, isGoldenEmployee
        ? renderActiveButtonContent()
        : renderInactiveButtonContent()));
};
var GoldBenefitBadge = styledWithTheme(View)(function (_a) {
    var theme = _a.theme, isGoldenEmployee = _a.isGoldenEmployee, isMobileViewport = _a.isMobileViewport;
    return "\n        background: ".concat(isGoldenEmployee
        ? "linear-gradient(-45deg, ".concat(theme.selectors.color('yellow50'), " 0 50%, ").concat(theme.selectors.color('yellow40'), " 50% 100%)")
        : theme.selectors.color('neutral10'), ";\n        border-radius: 50%;\n        border: ").concat(isGoldenEmployee
        ? 'none'
        : "1px dashed ".concat(theme.selectors.color('neutral70')), ";\n        cursor: pointer;\n        display: block;\n        height: ").concat(getGoldBenefitBadgeSize(isMobileViewport), ";\n        padding: 0;\n        position: relative;\n        text-align: center;\n        width: ").concat(getGoldBenefitBadgeSize(isMobileViewport), ";\n        box-shadow: ").concat(isGoldenEmployee
        ? "2px 2px 0 0 ".concat(theme.selectors.color('yellow60'))
        : 'none', ";\n        opacity: ").concat(isGoldenEmployee ? '1' : '52%', ";\n");
});
var commonTextStyle = "\n    font-size: 12px;\n    font-weight: bold;\n    left: 50%;\n    position: absolute;\n    top: 48%;\n    transform: translate(-50%, -50%);\n";
var GoldBenefitText = styledWithTheme(Text)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), commonTextStyle);
var GoldBenefitTextInactive = styledWithTheme(Text)(function (_a) {
    var theme = _a.theme;
    return " \n    color: ".concat(theme.selectors.color('neutral70'), ";\n    ").concat(commonTextStyle, "\n    ");
});
var templateObject_1;
